import React from "react";
import CashAndCheque from "./index";

const ChequeBookPage = () => {
  return <CashAndCheque mode="cheque" />;
};

export default ChequeBookPage;


